import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import { Outlet } from "react-router-dom";

export default function Layout(){

 return(

 <div className="flex">

  <Sidebar/>

  <div className="flex-1">

   {/* <Navbar/> */}

   <div className="ml-60 mt-16 p-6">

    <Outlet/>

   </div>

  </div>

 </div>

 );

}